import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthQuery } from '../auth-http-client';
import { entityWithNameSchema } from '../types';

export type GetPlayerAllQueryParams = number[];

export const createGetPlayerAllQuery = () =>
	createAuthQuery({
		params: declareParams<GetPlayerAllQueryParams>(),
		request: {
			method: 'GET',
			url: '/player/all',
			query: (ids) => (ids.length > 0 ? { accountIds: ids.map(String) } : {}),
		},
		response: {
			contract: zodContract(entityWithNameSchema.array()),
		},
	});
